
<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Clientes</v-toolbar-title>
      <v-spacer></v-spacer>

      <ClientFormDlg
        :dialog="frmUserDialog"
        :openForm="() => openDialogForm()"
        :closeForm="() => closeDialogForm()"
        :saveClient="(data) => saveClient(data)"
        :editFormData="formData"
      />
    </v-toolbar>
    <SearchClients :searchClients="(user) => initialize(user)" />
    <v-data-table :headers="headers" :items="tableData">
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon color="success" v-if="props.item.active">check_circle</v-icon>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                style="cursor: pointer"
                color="error"
                v-if="!props.item.active"
                v-on="on"
                >block</v-icon
              >
            </template>
            <span
              >Data da desativação
              {{ props.item.disable_date | moment("DD/MM/YYYY") }}</span
            >
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          {{ props.item.created_at | moment("DD/MM/YYYY") }}
        </td>
        <td class="text-xs-left">
          {{ props.item.name }}
          <br />
          <small>{{ props.item.accountable }}</small>
        </td>
        <td class="text-xs-left">{{ props.item.document | formatCnpjCpf }}</td>
        <td class="text-xs-center">
          {{ props.item.updated_at | moment("DD/MM/YYYY") }}
        </td>
        <td class="text-xs-center layout">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon
            small
            class="mr-2"
            @click="confirmToogleStatusItem(props.item)"
            v-if="!props.item.active"
            >check</v-icon
          >
          <v-icon
            small
            class="mr-2"
            @click="confirmToogleStatusItem(props.item)"
            v-if="props.item.active"
            >block</v-icon
          >
          <v-icon small @click="confirmDelUser(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <p>Não há dados</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ClientFormDlg from './ClientsForm.vue'
import SearchClients from './SearchClients.vue'
import axios from 'axios'

export default {
  name: 'Clients',

  components: {
    ClientFormDlg,
    SearchClients
  },

  data () {
    return {
      frmUserDialog: false,
      formData: null,
      headers: [
        {
          text: 'Status',
          align: 'center',
          sortable: true,
          value: 'active'
        },
        {
          text: 'Criado em',
          value: 'created_at',
          sortable: false,
          align: 'center'
        },
        { text: 'Nome/Razão social', sortable: true, value: 'name' },
        { text: 'CPF/CNPJ', value: 'document', sortable: false },
        {
          text: 'Última alteração',
          value: 'updated_at',
          sortable: false,
          align: 'center'
        },
        { text: ' ', value: '', sortable: false, align: 'center' }
      ],
      tableData: []
    }
  },

  beforeMount () {
    let obj = {
      bg: './img/insight_img_bg_1.jpg',
      logo: './img/logo.png'
    }
    this.$vuetify.theme.primary = '#002857'
    this.$store.commit('setNewThemeSystem', obj)
  },

  mounted () {
    this.initialize()
  },

  methods: {
    confirmDelUser (data) {
      let obj = {
        message: `Você deseja excluir o cliente "${data.name}"?`,
        title: 'Excluir cliente',
        callback: (_) => {
          this.delUser(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delUser (data) {
      let obj = {
        url: '/api/user/' + data.id,
        query: '',
        method: 'delete'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `cliente removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.initialize()
      })
    },

    confirmToogleStatusItem (data) {
      // console.log(data);
      let action = data.active ? 'desativar' : 'ativar'
      let obj = {
        message: `Você deseja ${action} o cliente "${data.name}"?`,
        title: `${data.active ? 'Desativar cliente' : 'Ativar cliente'}`,
        callback: (_) => {
          this.toogleStatusItem(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    toogleStatusItem (data) {
      let obj = {
        url: '/api/user/desative/' + data.id,
        query: '',
        method: 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Status modificado com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.initialize()
      })
    },

    openDialogForm () {
      this.formData = null
      this.frmUserDialog = true
    },

    closeDialogForm () {
      this.frmUserDialog = false
    },

    initialize (user) {
      let dataSearch = {}
      if (user && user.name) {
        dataSearch.params = {
          ...user
        }
      }
      let obj = {
        url: '/api/user',
        query: dataSearch,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.tableData = response.data
      })
    },

    editItem (item) {
      this.formData = Object.assign({}, item)
      this.frmUserDialog = true
    },

    async saveClientTheme (data) {
      let USER_TOKEN = localStorage.getItem('token')
      let AuthStr = 'Bearer '.concat(USER_TOKEN)
      let formData = new FormData()

      // user_id, color, logo, background file_name_logo e file_name_background
      let returnData
      formData.append('user_id', data.user_id)
      formData.append('logo', data.imageFile)
      formData.append('background', data.imageFileBg)
      formData.append('file_name_logo', data.imageName)
      formData.append('file_name_background', data.imageNameBg)
      formData.append('color', data.clientColor)

      axios.defaults.baseURL =
        process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_API_URL
          : /* 'http://187.103.137.78''http://192.168.20.41:9000''http://172.16.224.54:9000' */ process
            .env.VUE_APP_API_URL_DEV
      await axios
        .post('/api/clienttheme_user', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: AuthStr
          }
        })
        .then((resp) => {
          this.$store.commit('hideLoader')
          returnData = resp.data
          // if (callback) {
          //   callback();
          // }
        })
        .catch((error) => {
          let paramModal = {}
          paramModal.message = error.response
            ? error.response.data.errors
              ? Object.values(error.response.data.errors).join('<br>')
              : error.response.data.message
            : 'Contate o administrador do sistema'
          paramModal.title = 'Ocorreu erro'
          paramModal.type = 'error'
          paramModal.callback = null
          paramModal.btConfirm = {
            name: 'Ok',
            show: true
          }
          paramModal.btCancel = {
            show: false
          }
          this.$store.commit('hideLoader')
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal)
        })
      return returnData
    },

    async saveClientModules (data) {
      let obj = {
        url: '/api/modules_available',
        query: data,
        method: 'post',
        noLoader: true
      }
      let returnData
      await this.$store.dispatch('request/doRequest', obj).then((response) => {
        returnData = response.data
      })
      return returnData
    },

    saveClient (data) {
      let id = data.id ? `/${data.id}` : ''
      let typeMethod = data.id ? 'put' : 'post'

      // data.type = "master";
      // data.profile_id = 1;

      console.log('imgs', data)

      // return;
      let obj = {
        url: '/api/user' + id,
        query: data,
        method: typeMethod,
        noLoader: true
      }
      this.$store.commit('showLoader', {
        circle: true
      })
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        data.modules_available.user_id = response.data.id
        data.theme.user_id = response.data.id
        this.saveClientModules(data.modules_available).then((_) => {
          this.saveClientTheme(data.theme).then((_) => {
            let opts = {
              message: `Cliente ${id ? 'alterado' : 'adicionado'} com sucesso`,
              type: 'success'
            }
            this.$store.commit('showAlert', opts)
            this.frmUserDialog = false
            this.initialize()
          })
        })
      })
    }
  },

  filters: {
    formatCnpjCpf (value) {
      if (value.length > 11) {
        value = value.replace(
          /^([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})$/,
          '$1.$2.$3/$4-$5'
        )
      } else {
        value = value.replace(
          /^([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})$/,
          '$1.$2.$3-$4'
        )
      }
      return value
    }
  }
}
</script>
